var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrrigationShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IRRIGATION_SHAPE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #IRRIGATION_SHAPE .cls-1 {\n        fill: #3e4346;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_IRRIGATION_SHAPE",
    transform: "translate(-461 -63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_62",
    "data-name": "Gruppe 62",
    transform: "translate(461 63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_142",
    "data-name": "Pfad 142",
    className: "cls-1",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_143",
    "data-name": "Pfad 143",
    className: "cls-1",
    d: "M28.2,17.2l-.9.9.8-1.3-.2-.6-2,3.4h0l-3.3,3.5h0l4.9-8.3-.1-.4.9-.2-4.6-3.6v.2l-1.4.4L14.5,24.4h0l-.9-.6,7.2-12.2-.6.2-7,11.8-.9-.6,6.9-11.6-.3-1.3L7.7,17.5l.3,1,.1-.2h0l2-1.4h0l-1.8,3,.3,1-.7.2,8.6,5.3-.2-.8.4-.1-.6-.4L24,11.9l.8.7L17.1,25.5l.6-.2,7.4-12.5h0l.8.7L19.3,25l.6-.2,6.5-11,.8.7h0l-6,10.1-.5.5.3,1,7.4-7.9ZM9.4,21l-.9-.6h0L11,16.2h0l2-1.4h0L9.4,21Zm.4.3h0l4.1-6.9h0l2-1.4h0l-5.3,8.9Zm1.3.8h0l5.7-9.7h0l2-1.4L12,22.6h0ZM15.8,25l-.9-.6,8-13.5h0l.8.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_144",
    "data-name": "Pfad 144",
    className: "cls-1",
    d: "M19.7,10.4l.2-.1v-.1ZM18.3,7.5l1.1,4.3,4.3-1.1L22.6,6.4Zm4.4,2.6-2.7.6-.7-2.6L22,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_145",
    "data-name": "Pfad 145",
    className: "cls-1",
    d: "M3.2,17.7,4.3,22l4.3-1L7.5,16.7Zm4.3,2.6L4.9,21l-.7-2.6,2.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_146",
    "data-name": "Pfad 146",
    className: "cls-1",
    d: "M16.3,25.7,17.4,30l4.4-1.1-1.1-4.3Zm4.4,2.6L18,29l-.7-2.6,2.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_147",
    "data-name": "Pfad 147",
    className: "cls-1",
    d: "M27.5,14.4l1.1,4.3,4.3-1.1-1.1-4.3ZM31.8,17l-2.6.7L28.5,15l2.6-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrrigationShape);
export default __webpack_public_path__ + "static/media/irrigation-shape.d594466bd3ca3fcbe097afbfe2c1ff9c.svg";
export { ForwardRef as ReactComponent };